module.exports = __webpack_public_path__ + "img/RECUADRO_Desarrollo.8e485a81.png";